import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
  label?: string;
};
export function Countdown({
  dark = false,
  label = "The special offer ends in:"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c48p6g6uyxfc">
      <p className={`mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-white" : "text-ink"}`} data-id="element-20" data-mp="3h2abd9zkzcv1">
        <ClockIcon className="h-4 w-4 text-refer" aria-hidden="true" data-id="element-21" data-mp="372t26il4egub" />
        {label}
      </p>
      <div className="flex items-start gap-2" data-id="element-22" data-mp="10cbsrg76aze9">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="10a8ru14hflur" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="15bofm0y1o6gu">
              <span className={`flex h-[68px] w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-black tabular-nums ${dark ? "bg-white text-ink" : "bg-navy text-white"}`} data-id="element-25" data-mp="159bwvlkgps2q">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-muted"}`} data-id="element-26" data-mp="12rd8d6kuhk7d">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 text-3xl font-black ${dark ? "text-white" : "text-ink"}`} data-id="element-27" data-mp="a4sg83wjp42r">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}